import { FC } from 'react';

import { config } from 'config';
import { SocialNetwork } from 'models';
import { IconTelegram } from 'components/icons/telegram';
import { IconFacebook } from 'components/icons/facebook';
import { IconTwitter } from 'components/icons/twitter';
import { IconWhatsapp } from 'components/icons/whatsapp';
import { IconVk } from 'components/icons/vk';
import { IconYoutube } from 'components/icons/youtube';
import { IconInstagram } from 'components/icons/instagram';
import { Container } from 'components/container';
import { About, Authors, Copyright, Heading, Social, SocialLinks, StyledFooter } from './styled';
import { useDataContext } from 'context/data-context';
import { useLocale } from 'locale';

type Props = {};

const socialConfig = {
  facebook: {
    icon: <IconFacebook />,
    linkUz: 'https://www.facebook.com/ozodlikradiosi',
    linkRu: '',
    newTab: true,
  },
  /*vkontakte: {
    icon: <IconVk />,
    linkUz: '',
    linkRu: '',
    newTab: true,
  },*/
  twitter: {
    icon: <IconTwitter />,
    linkUz: 'https://twitter.com/ozodlik',
    linkRu: '',
    newTab: true,
  },
  instagram: {
    icon: <IconInstagram />,
    linkUz: 'https://www.instagram.com/ozodlikradiosi/',
    linkRu: '',
    newTab: true,
  },
  telegram: {
    icon: <IconTelegram />,
    linkUz: 'https://t.me/ozodlikkanali',
    linkRu: '',
    newTab: true,
  },
  youtube: {
    icon: <IconYoutube />,
    linkUz: 'https://www.youtube.com/user/Ozodlikradiosi',
    linkRu: '',
    newTab: true,
  },
  whatsapp: {
    icon: <IconWhatsapp />,
    linkUz: 'https://whatsapp.com/channel/0029VaRV39qB4hdN2ux7XN2E',
    linkRu: '',
    newTab: true,
  },
  // rss: { icon: <IconRss />, newTab: false },
};

const parseSocial = (appLocale: typeof config.locale) => (
  <SocialLinks>
    {(Object.keys(socialConfig) as SocialNetwork[]).map((k) => {
      const networkConfig = socialConfig[k];

      return networkConfig ? (
        <li key={k}>
          <a
            href={appLocale === 'uz' ? networkConfig.linkUz : networkConfig.linkRu}
            {...(networkConfig.newTab ? { target: '_blank' } : null)}
          >
            {networkConfig.icon}
          </a>
        </li>
      ) : null;
    })}
  </SocialLinks>
);

export const Footer: FC<Props> = () => {
  const { appLocale } = useDataContext();
  const locale = useLocale();

  return (
    <StyledFooter>
      <Container>
        <Authors>
          <Heading>{locale.footer.creatorsTitle}</Heading>
          {locale.footer.creators}
        </Authors>
        <Social>
          <Heading>{locale.footer.followUs}</Heading>
          {parseSocial(appLocale)}
        </Social>
        <About>
          <Heading>{locale.footer.contentTitle}</Heading>
          <p>{locale.footer.content}</p>
        </About>
        <Copyright>{locale.footer.copyright}</Copyright>
      </Container>
    </StyledFooter>
  );
};
